import React from 'react'
import Introduction from '../Components/Introduction'
import starcorporate from '../Assets/logo-starcorporate1.webp'
import Services from '../Components/Services'
import CardServices from '../Components/CardServices'
import MarketAnalysis from '../Components/MarketAnalysis'
import gspLogo from '../Assets/gsp-logo.webp'
import karlaLogo from '../Assets/karla-logo.webp'
import noahLogo from '../Assets/noah-logo.webp'
import volarLogo from '../Assets/volar-gsp.webp'
import lilianLogo from '../Assets/lilian-logo.webp'
import fixxbankLogo from '../Assets/logo-fixxbank.webp'
import fixxinvestLogo from '../Assets/logo-fixxinvest.webp'

function StarCorporate({ id }) {
  return (
    <section id={id}>
      <Introduction
        srcLogo={starcorporate}
        altLogo="Star Corporate"
        description={
          <>
            A Star Corporate se estabelece como uma agência focada no
            reposicionamento digital para empresas. Localizada em Florianópolis
            - um polo de inovação tecnológica -, a empresa se dedica a
            impulsionar o crescimento de empresas que visam liderança e
            excelência em seus segmentos. Seu portfólio, enriquecido por mais de
            uma década de expertise, reflete uma trajetória de sucesso em
            estratégias de branding, marketing, publicidade e propaganda e
            soluções personalizadas, consolidando a posição da marca em busca de
            uma presença influente.
          </>
        }
        backgroundColor="#010B17"
        color="white"
        img={false}
      />
      <div
        className="padding-100 flex-center flex-column flex__gap-50"
        data-aos="fade-up"
      >
        <div className="flex-center flex__gap-50 flex__wrap">
          <div className="img img-140">
            <img src={gspLogo} alt="GSP" />
          </div>
          <div className="img img-140">
            <img src={karlaLogo} alt="Karla Shenk" />
          </div>
          <div className="img img-120">
            <img src={noahLogo} alt="Noah Saúde Bucal" />
          </div>
          <div className="img img-140">
            <img src={volarLogo} alt="Volar Tour" />
          </div>
        </div>
        <div className="flex-center flex__gap-50 flex__wrap">
          <div className="img img-140">
            <img src={lilianLogo} alt="Lilian Galasso" />
          </div>
          <div className="img img-140">
            <img src={fixxbankLogo} alt="Fixxbank" />
          </div>
          <div className="img img-140">
            <img src={fixxinvestLogo} alt="Fixxinvest" />
          </div>
        </div>
      </div>

      <Services backgroundColor="#ECF0F1" colorTitle="#121212">
        <CardServices
          title="Mapeamento de Oportunidades de Mercado"
          description="Identificação e análise de oportunidades de mercado, organizadas por setor de atuação, com insights diretos para facilitar a tomada de decisão estratégica."
          backgroundColor="#010B17"
          colorTitle="white"
          colorContent="white"
          height="260px"
        />
        <CardServices
          title="Análise Empresarial"
          description="Avaliação do posicionamento atual da empresa e seu potencial de crescimento, abrangendo desde operações internas até estratégias de marketing e presença digital."
          backgroundColor="#010B17"
          colorTitle="white"
          colorContent="white"
          height="260px"
        />
        <CardServices
          title="Desenvolvimento Corporativo"
          description="Suporte integral no desenvolvimento de projetos empresariais, incluindo branding corporativo, marketing digital, estruturação de vendas e elaboração de planos de ação empresariais."
          backgroundColor="#010B17"
          colorTitle="white"
          colorContent="white"
          height="260px"
        />
        <CardServices
          title="Soluções Digitais"
          description="Especialização na criação e otimização de websites corporativos e presença digital, visando maximizar a visibilidade e interação com clientes e stakeholders."
          backgroundColor="#010B17"
          colorTitle="white"
          colorContent="white"
          height="260px"
        />
        <CardServices
          title="Marketing de Influência"
          description="Parcerias estratégicas com influenciadores digitais para ampliar o alcance da marca e estabelecer confiança com o público. Seleção cuidadosa de influenciadores alinhados com os valores e público-alvo da empresa, para campanhas autênticas e eficazes"
          backgroundColor="#010B17"
          colorTitle="white"
          colorContent="white"
          height="260px"
        />
        <CardServices
          title="Publicidade e Propaganda"
          description="Criação e execução de campanhas publicitárias que capturam a essência da marca e se conectam emocionalmente com o público-alvo. Utilização de uma variedade de meios, incluindo mídia digital, impressa e externa, para maximizar o alcance e impacto."
          backgroundColor="#010B17"
          colorTitle="white"
          colorContent="white"
          height="260px"
        />
        <CardServices
          title="Audiovisual"
          description="Produção de conteúdo audiovisual de alta qualidade, incluindo vídeos promocionais, comerciais de TV, e conteúdo para redes sociais. Enfoque na narrativa visual e storytelling para engajar audiências e promover a imagem da marca."
          backgroundColor="#010B17"
          colorTitle="white"
          colorContent="white"
          height="260px"
        />
        <CardServices
          title="Tráfego"
          description="Estratégias especializadas para aumentar o tráfego para websites e plataformas digitais, utilizando SEO, marketing de conteúdo, campanhas pagas em redes sociais e motores de busca. Análise e otimização contínua para garantir o máximo retorno sobre investimento"
          backgroundColor="#010B17"
          colorTitle="white"
          colorContent="white"
          height="260px"
        />
        <CardServices
          title="Estratégias de Conteúdo"
          description="Desenvolvimento e implementação de estratégias de conteúdo sob medida, destinadas a engajar o público-alvo, construir autoridade de marca e otimizar a jornada do cliente. Criação de conteúdo relevante e valioso que ressoa com as necessidades e interesses dos clientes."
          backgroundColor="#010B17"
          colorTitle="white"
          colorContent="white"
          height="260px"
        />
      </Services>

      <MarketAnalysis
        description={
          <>
            <br />
            <br />
            Empresas de desenvolvimento digital, como a Star Corporate, operam
            em um ambiente dinâmico e altamente competitivo, onde a inovação e a
            capacidade de antecipar e responder às mudanças nas demandas dos
            consumidores e tecnologias emergentes são fundamentais para o
            sucesso.
            <br />
            <br /> A expectativa dos consumidores por experiências digitais
            personalizadas e imediatas está aumentando. Empresas que oferecem
            soluções customizadas, capazes de coletar e analisar dados para
            fornecer serviços personalizados, estão melhor posicionadas para
            capturar e reter clientes.
            <br />
            <br /> A consolidação do mercado é uma tendência, à medida que
            empresas maiores adquirem startups promissoras para expandir suas
            capacidades tecnológicas e ofertas de serviços. A capacidade da Star
            Corporate de inovar, adaptar-se rapidamente às novas tecnologias e
            entender profundamente as necessidades dos clientes é crucial para o
            sucesso neste mercado.
          </>
        }
        backgroundColor="#010B17"
        colorTitle="white"
        colorContent="white"
        colorSvg="white"
        news="A publicidade digital, na qual empresas e instituições utilizam canais on-line para divulgação de produtos, serviços e campanhas, movimentou R$ 16,4 bilhões no Brasil durante o primeiro semestre de 2023. O resultado representa um crescimento de 11% sobre o mesmo período do ano passado."
        backgroundNews="white"
        colorNews="#121212"
      />
    </section>
  )
}

export default StarCorporate
